import type {
  ChangePasswordRequest,
  MyESignResponse,
  NotificationPreferenceItem,
  UpdateMyProfileRequest,
  UserSummary,
} from '@todo/shared';
import { api, get, patch } from './client';

/** /api/me - the signed-in person acting on themselves. */
export const meApi = {
  updateProfile(body: UpdateMyProfileRequest): Promise<UserSummary> {
    return patch<UserSummary>('/me/profile', body);
  },

  async setAvatar(file: File): Promise<void> {
    await api.post('/me/avatar', file, {
      headers: { 'Content-Type': file.type },
    });
  },

  async changePassword(body: ChangePasswordRequest): Promise<void> {
    await api.post('/me/password', body);
  },

  notificationPreferences(): Promise<NotificationPreferenceItem[]> {
    return get<NotificationPreferenceItem[]>('/me/notification-preferences');
  },

  async saveNotificationPreferences(
    preferences: NotificationPreferenceItem[],
  ): Promise<void> {
    await api.put('/me/notification-preferences', { preferences });
  },

  /** My saved E-Sign (short-lived preview URL, or null). */
  getESign(): Promise<MyESignResponse> {
    return get<MyESignResponse>('/me/esign');
  },

  saveESign(signatureDataUrl: string): Promise<MyESignResponse> {
    return api
      .put<{ data: MyESignResponse }>('/me/esign', { signatureDataUrl })
      .then((r) => r.data.data);
  },

  async removeESign(): Promise<void> {
    await api.delete('/me/esign');
  },
};
